import type { Handleiding } from './soort';

export const pl: Handleiding = {
  code: 'pl',
  titel: 'Instrukcja',
  inleiding:
    'Ask Gio Tolk tłumaczy rozmowę między dwiema osobami, które nie mówią tym samym językiem. Poniżej znajdziesz, co robi każdy przycisk.',
  knop: 'Otwórz instrukcję',
  sluiten: 'Zamknij',
  groepGebruik: 'Rozmawiać',
  groepBeheer: 'Ustawienia i zarządzanie',
  delen: [
    {
      titel: 'Mówienie',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Mów',
          uitleg:
            'Dotknij raz, żeby zacząć. Nagrywanie zatrzymuje się samo, gdy milczysz przez nieco ponad sekundę, albo gdy dotkniesz jeszcze raz. Po minucie zatrzyma się tak czy inaczej.',
        },
        {
          kop: 'Jeden dźwięk naraz',
          uitleg:
            'Dopóki aplikacja mówi, nie możesz nagrywać. A dopóki nagrywasz, przychodzące tłumaczenie czeka, aż skończysz. Inaczej mikrofon nagra aplikację i uzna, że to ty tak powiedziałeś.',
        },
        {
          kop: 'Wpisz tutaj wiadomość',
          uitleg:
            'Działa obok mówienia i idzie przez to samo tłumaczenie. Enter wysyła, shift z enterem robi nową linię.',
        },
        {
          kop: 'Czas na poprawki',
          uitleg:
            'Tutaj ustawiasz, ile sekund masz na przeczytanie zapisanego zdania, zanim pójdzie dalej. Przy zerze idzie od razu.',
        },
        {
          kop: 'Zawsze sam sprawdzaj i wysyłaj',
          uitleg:
            'Żadnego zegara. Każde zdanie czeka, aż naciśniesz wyślij. Dla kogoś, kto chce sprawdzić każde zdanie.',
        },
        {
          kop: 'Odtwarzaj tłumaczenie od razu',
          uitleg:
            'Jest włączone. Wyłącz je, jeśli wolisz najpierw przeczytać i sam decydować, kiedy słuchasz.',
        },
      ],
    },
    {
      titel: 'Czytanie wiadomości',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'To, co jest duże',
          uitleg:
            'To, co jest w TWOIM języku, jest duże. Przy twoim własnym zdaniu to twój oryginalny tekst, żebyś mógł sprawdzić, czy aplikacja dobrze cię zrozumiała. Przy zdaniu drugiej osoby to tłumaczenie.',
        },
        {
          kop: 'Rozwijanie oryginału lub tłumaczenia',
          uitleg: 'Drugi język jest pod spodem, zwinięty. Dotknij wiersza, żeby go otworzyć.',
        },
        {
          kop: 'Trójkącik',
          uitleg: 'Odtwarza tłumaczenie jeszcze raz.',
        },
        {
          kop: 'Mówiąca głowa',
          uitleg:
            'Odtwarza własne nagranie drugiej osoby. Pojawia się tylko przy wiadomości MÓWIONEJ i tylko wtedy, gdy „wyślij też własny głos” jest włączone. Wiadomość napisana nie ma nagrania.',
        },
      ],
    },
    {
      titel: 'Przyciski u góry ekranu',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Minus i plus',
          uitleg: 'Zmniejsza albo powiększa tekst. W pięciu krokach, i zostaje zapamiętane.',
        },
        {
          kop: 'Mikrofon',
          uitleg: 'Ukrywa przycisk mówienia, jeśli i tak tylko piszesz. To oszczędza miejsce.',
        },
        {
          kop: 'Klawiatura',
          uitleg:
            'Ukrywa pole tekstowe. Zawsze zostaje jedno z dwóch, inaczej nie mógłbyś już nic powiedzieć.',
        },
      ],
    },
    {
      titel: 'Wejście',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Jakim językiem mówisz',
          uitleg:
            'Ten wybór ustala też język przycisków i komunikatów. Każde z was widzi więc inny ekran, i o to chodzi.',
        },
        {
          kop: 'Twój głos w tłumaczeniu',
          uitleg:
            'Wybierz, czy brzmisz jak mężczyzna czy jak kobieta. To należy do CIEBIE, nie do pokoju: każdy uczestnik wybiera osobno.',
        },
        {
          kop: 'Zgoda na mikrofon',
          uitleg:
            'Przeglądarka pyta o to przy wejściu. Jeśli odmówisz, nadal możesz pisać. Zgodę można dać później przez kłódkę w pasku adresu.',
        },
      ],
    },
    {
      titel: 'Na dole, zwinięte',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Awaryjna lista słów',
          uitleg:
            'Słowa, które zawsze muszą być tłumaczone tak samo: nazwiska, terminy fachowe, marki. Dotyczy całego pokoju.',
        },
        {
          kop: 'Zmiana ustawień',
          uitleg:
            'Język, głos, ton i poprawianie pisowni można zmienić także W TRAKCIE rozmowy. To, co tu zmienisz, obowiązuje od razu dla obojga.',
        },
      ],
    },
    {
      titel: 'Rozpoczęcie rozmowy',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Nazwa rozmowy',
          uitleg:
            'Może zostać pusta. Pojawia się tylko u góry twojego ekranu, żebyś wiedział, z kim rozmawiasz.',
        },
        {
          kop: 'Mówca 1 i mówca 2',
          uitleg:
            'Dwa języki tej rozmowy. Kto wejdzie pierwszy, dostaje pierwsze miejsce. Języki można później jeszcze zamienić.',
        },
        {
          kop: 'Ton tłumaczenia',
          uitleg:
            'Po lewej wybierasz formę na ty albo na pan i pani, po prawej nastrój: neutralny, przyjacielski, służbowy, oficjalny albo partnerski. Bez wskazówki model wybiera prawie zawsze formę oficjalną, a w zwykłej rozmowie brzmi to z dystansem.',
        },
        {
          kop: 'Wyślij też własny głos',
          uitleg:
            'Druga osoba może usłyszeć obok tłumaczenia także twoje własne nagranie. Przydatne przy nauce języka. Wyłącz to przy delikatnej rozmowie: kto dostanie nagranie, może je zachować.',
        },
        {
          kop: 'Popraw błędy w twoim własnym tekście',
          uitleg:
            'Jest włączone. Wyłącz je, żeby zobaczyć, co model naprawdę zrozumiał. Jeśli wyjdzie dziwne zdanie, wiesz, czy zostało źle zrozumiane, czy dobrze zrozumiane i potem wygładzone.',
        },
        {
          kop: 'Z kodem PIN',
          uitleg:
            'Podaj kod ustnie, nie w tej samej wiadomości co link. To chroni przed przesłanym dalej linkiem.',
        },
        {
          kop: 'Kod QR',
          uitleg:
            'Niech druga osoba go zeskanuje, albo wyślij link. Pokój wygasa sam po czterech godzinach.',
        },
      ],
    },
    {
      titel: 'Co dzieje się z twoją rozmową',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Tekst nie jest przechowywany',
          uitleg:
            'To, co mówicie, nie trafia do bazy danych. Tylko kiedy i ile rozmawiano, na potrzeby kosztów.',
        },
        {
          kop: 'Nagrania znikają same',
          uitleg: 'Dźwięk zostaje dziesięć minut w pamięci, a potem znika.',
        },
        {
          kop: 'Pokój wygasa',
          uitleg: 'Cztery godziny po utworzeniu. Potem link już nie działa.',
        },
        {
          kop: 'Jest budżet',
          uitleg:
            'Na pokój i na miesiąc. Gdy się wyczerpie, aplikacja przestaje tłumaczyć i mówi o tym. To nie awaria.',
        },
      ],
    },
  ],
};
